import { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const checkedRef = useRef(false);

  const checkSession = useCallback(() => {
    if (checkedRef.current) return;
    checkedRef.current = true;
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (window.location.pathname.startsWith("/admin")) checkSession();
  }, [checkSession]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    checkedRef.current = true;
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, checkSession }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
